//@ts-ignore
import h from 'virtual-dom/h'
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../../settings/alight-custom-settings';
import {VChild, VTree} from "virtual-dom";
import { HistoryMessage, HistoryMessageAlme } from '@alme/ui-web/types/history';

type ChildRenderer = (message: HistoryMessage) => VChild;

export default class AdvocacyChatBubbleRenderer {
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;
    _mutators: any;
    _preRenderers: ChildRenderer[] = [];
    _messageRenderers: ChildRenderer[] = [];
    _postRenderers: ChildRenderer[] = [];

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>, mutatorModules = [], 
        preRenderers: ChildRenderer[] = [],
        messageRenderers: ChildRenderer[] = [], 
        postRenderers: ChildRenderer[] = []) : void {
        this._store = store;
        this._mutators = mutatorModules;
        this._preRenderers = preRenderers;
        this._messageRenderers = messageRenderers
        this._postRenderers = postRenderers;
    }

    doesRender(message: HistoryMessage) {
        return message.type === this._settings.messageConstants.advocacyProactiveResponse;
    }

    getRender(): (message: HistoryMessage) => VChild
    {
        return (message: HistoryMessage) => {
            if(!this.doesRender(message)) return;

            const almeMessage = message as HistoryMessageAlme;

            let responseText = almeMessage.text;

            let parameters = {
                className : this._settings.classNames.almeResponseClassName
            };
            parameters = this._mutators.reduce((params: any, mutate: any) =>
                params = mutate(params), parameters);

            // let reduceRenderers = (renderers: any[], message: any) =>
            //     renderers.reduce((arr, render) =>
            //         arr.concat(render(message)), []);

            const preNodes = this.renderNodes(this._preRenderers, almeMessage);
            // reduceRenderers(this._preRenderers, message);
            const messageChildNodes = this.renderNodes(this._messageRenderers, almeMessage);
            const postNodes = this.renderNodes(this._postRenderers, almeMessage);
            //const postNodes = reduceRenderers(this._postRenderers, message);


            let messageNodes: any = [
                h('div', {
                    className : this._settings.classNames.almeResponsePersonaIconClassName,
                }),
                h('div', {
                    className : this._settings.classNames.almeResponseMessageClassName,
                    attributes:{
                        'data-advocacybubble': true
                    }
                }, [
                    h('div', {
                        className : this._settings.classNames.almeResponseTextClassName
                    }, responseText ),
                    ...messageChildNodes
                ])
            ];

            return h('div', parameters, [...preNodes, ...messageNodes, ...postNodes]);
        }
    }

    renderNodes(renderers: ChildRenderer[], message: HistoryMessageAlme): VTree[]
    {
        return renderers.reduce((nodes, render) => [...nodes, render(message) as VTree], [] as VTree[]);
    }
}


// WEBPACK FOOTER //
// ./modules/advocacy-chat-bubble/renderers/chat-bubble-renderer.ts